/*@flow*/
/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import { LEVEL, BREAKPOINT_MD } from 'store/constants';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { hot } from 'react-hot-loader';

const Nav = styled.nav`
  padding: 20px 20px 10px;
  z-index: ${LEVEL.PAGE_NAV};
  position: relative;
  background: var(--brand-yellow);
  display: flex;
`;

const Component = () => (
  <Nav>
    <Link
      to="/"
      css={css(
        `font-size: var(--font-size-h-one);
        font-weight: bold;
        color: var(--brand-black);
        &:hover, &:active { color: var(--brand-black); }
        @media (max-width: ${BREAKPOINT_MD.toString()}) {
          font-size: 1rem;
        }
      `
      )}
    >
      The Circular City
    </Link>
    <div
      css={css(`
            display: grid;
            align-items: center;
            font-size: var(--font-size-h-two);
            margin-left: 20px;
            border-left: solid 1px var(--brand-black);
            padding-left: 20px;
          `)}
    >
      Downtown Brooklyn Dashboard
    </div>
  </Nav>
);

export default hot(module)(Component);
